export const CLIENT_LOCAL = "app-mexico-seguro";

export const AVAILABLE_ROUTES = [
  "/",
  "/contactos",
  "/notificaciones",
  "/ajustes",
];

export const REGISTER = "REGISTRADO";
export const WAITING_FOR_ASSIGNMENT = "EN ESPERA DE ASIGNACION";
export const ASSIGNED = "ASIGNADO";
export const CONFIRMED_ASSISTANCE = "ASISTENCIA CONFIRMADA";
export const VACCINATED = "VACUNADO";
// type of reasons
export const VERIFY = "VERIFICADO";
export const NOT_VERIED = "NO VERIFICADO";

export const COMPLAINT = "COMPLAINT";
export const REPORT = "REPORT";
export const SUGGESTION = "SUGGESTION";
export const CONGRATS = "CONGRATS";

export const LABEL_REPORT = "Reporte";
export const LABEL_SUGGESTION = "Sugerencia";
export const LABEL_CONGRATS = "Felicitar";

export const CAR_PRIVATE = "PRIVATE";
export const CAR_PUBLIC = "PUBLIC";

export const LABEL_CAR_PRIVATE = "Particular";
export const LABEL_CAR_PUBLIC = "Transporte";

export const STOLEN_CAR = "STOLEN_CAR";
export const LABEL_STOLEN_CAR = "Robo de Vehículo";

// export const RECOVERED = "RECOVERED";
// export const IN_RESEARCH = "IN_RESEARCH";
// export const ALERT_ISSUED = "ALERT_ISSUED";
// export const STOLEN = "STOLEN";
// export const LABEL_RECOVERED = "Recuperado";
// export const LABEL_IN_RESEARCH = "En investigación";
// export const LABEL_ALERT_ISSUED = "Alerta emitida";
// export const LABEL_STOLEN = "Robado";

export const optionsListStolen = [{ id: STOLEN_CAR, title: LABEL_STOLEN_CAR }];

export const optionsListReasons = [
  { id: REPORT, title: LABEL_REPORT },
  { id: SUGGESTION, title: LABEL_SUGGESTION },
  { id: CONGRATS, title: LABEL_CONGRATS },
];

export const optionsTypeVehicle = [
  { id: CAR_PRIVATE, title: LABEL_CAR_PRIVATE },
  { id: CAR_PUBLIC, title: LABEL_CAR_PUBLIC },
];

export const optionsYears = [
  { id: 1952, title: 1952 },
  { id: 1953, title: 1953 },
  { id: 1954, title: 1954 },
  { id: 1955, title: 1955 },
  { id: 1956, title: 1956 },
  { id: 1957, title: 1957 },
  { id: 1958, title: 1958 },
  { id: 1959, title: 1959 },
  { id: 1960, title: 1960 },
  { id: 1961, title: 1961 },
  { id: 1962, title: 1962 },
  { id: 1963, title: 1963 },
  { id: 1964, title: 1964 },
  { id: 1965, title: 1965 },
  { id: 1966, title: 1966 },
  { id: 1967, title: 1967 },
  { id: 1968, title: 1968 },
  { id: 1969, title: 1969 },
  { id: 1970, title: 1970 },
  { id: 1971, title: 1971 },
  { id: 1972, title: 1972 },
  { id: 1973, title: 1973 },
  { id: 1974, title: 1974 },
  { id: 1975, title: 1975 },
  { id: 1976, title: 1976 },
  { id: 1977, title: 1977 },
  { id: 1978, title: 1978 },
  { id: 1979, title: 1979 },
  { id: 1980, title: 1980 },
  { id: 1981, title: 1981 },
  { id: 1982, title: 1982 },
  { id: 1983, title: 1983 },
  { id: 1984, title: 1984 },
  { id: 1985, title: 1985 },
  { id: 1986, title: 1986 },
  { id: 1987, title: 1987 },
  { id: 1988, title: 1988 },
  { id: 1989, title: 1989 },
  { id: 1990, title: 1990 },
  { id: 1991, title: 1991 },
  { id: 1992, title: 1992 },
  { id: 1993, title: 1993 },
  { id: 1994, title: 1994 },
  { id: 1995, title: 1995 },
  { id: 1996, title: 1996 },
  { id: 1997, title: 1997 },
  { id: 1998, title: 1998 },
  { id: 1999, title: 1999 },
  { id: 2000, title: 2000 },
  { id: 2001, title: 2001 },
  { id: 2002, title: 2002 },
  { id: 2003, title: 2003 },
  { id: 2004, title: 2004 },
  { id: 2005, title: 2005 },
  { id: 2006, title: 2006 },
  { id: 2007, title: 2007 },
  { id: 2008, title: 2008 },
  { id: 2009, title: 2009 },
  { id: 2010, title: 2010 },
  { id: 2011, title: 2011 },
  { id: 2012, title: 2012 },
  { id: 2013, title: 2013 },
  { id: 2014, title: 2014 },
  { id: 2015, title: 2015 },
  { id: 2016, title: 2016 },
  { id: 2017, title: 2017 },
  { id: 2018, title: 2018 },
  { id: 2019, title: 2019 },
  { id: 2020, title: 2020 },
  { id: 2021, title: 2021 },
  { id: 2022, title: 2022 },
];

export const getLabelReason = (type) => {
  let label;
  switch (type) {
    case REPORT:
      label = LABEL_REPORT;
      break;
    case SUGGESTION:
      label = LABEL_SUGGESTION;
      break;
    default:
      label = LABEL_CONGRATS;
      break;
  }

  return label;
};

export const getLabelTypeCar = (type) => {
  let label;
  switch (type) {
    case CAR_PRIVATE:
      label = LABEL_CAR_PRIVATE;
      break;
    default:
      label = LABEL_CAR_PUBLIC;
      break;
  }

  return label;
};

// type profiles system for rules
export const ADMIN = "ADMIN";
export const EMPLOYEE = "EMPLOYEE";

export const LABEL_ADMIN = "Administrador";
export const LABEL_EMPLOYEE = "Empleado";

// type status of report

export const RECOVERED = "RECOVERED";
export const IN_RESEARCH = "IN_RESEARCH";
export const ALERT_ISSUED = "ALERT_ISSUED";
export const STOLEN = "STOLEN";

export const LABEL_RECOVERED = "Recuperado";
export const LABEL_IN_RESEARCH = "En investigación";
export const LABEL_ALERT_ISSUED = "Alerta emitida";
export const LABEL_STOLEN = "Robado";

export const DATA_PROFILES = [
  { _id: ADMIN, title: LABEL_ADMIN },
  { _id: EMPLOYEE, title: LABEL_EMPLOYEE },
];

export const DATA_STATUS = [
  { _id: RECOVERED, title: LABEL_RECOVERED },
  { _id: IN_RESEARCH, title: LABEL_IN_RESEARCH },
  { _id: ALERT_ISSUED, title: LABEL_ALERT_ISSUED },
  { _id: STOLEN, title: LABEL_STOLEN },
];

export const getLabelProfile = (type) => {
  let label;
  switch (type) {
    case ADMIN:
      label = LABEL_ADMIN;
      break;

    default:
      label = LABEL_EMPLOYEE;
      break;
  }

  return label;
};

export const getLabelStatus = (type) => {
  let label;
  switch (type) {
    case RECOVERED:
      label = LABEL_RECOVERED;
      break;
    case IN_RESEARCH:
      label = LABEL_IN_RESEARCH;
      break;
    case ALERT_ISSUED:
      label = LABEL_ALERT_ISSUED;
      break;

    default:
      label = LABEL_EMPLOYEE;
      break;
  }

  return label;
};

export const DEFAULT_COVER =
  "https://secondchancetinyhomes.org/wp-content/uploads/2016/09/empty-profile.png";

export const getMessageByStatus = (status) => {
  let message;
  let color;
  switch (status) {
    case REGISTER:
      message = "Para continuar se necesita el pago de la vacuna.";
      color = "error";
      break;
    case WAITING_FOR_ASSIGNMENT:
      message =
        "Pago de vacuna realizado,  por favor espera a que confirmen disponibilidad para tu vacuna.";
      color = "primary";
      break;
    case ASSIGNED:
      message =
        "Hola, es momento de que escojas el dia y lugar de tu vacunación.";
      color = "primary";
      break;
    case CONFIRMED_ASSISTANCE:
      message = "Felicidades, ya cuentas con fecha de vacunación.";
      color = "primary";
      break;
    case VACCINATED:
      message = "¡Ahora estas vacunado!";
      color = "primary";
      break;

    default:
      message = "";
      color = "primary";
      break;
  }

  return { message, color };
};
